export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";